import React from "react";
import './loader.css';
import loaderImg from '../../assets/images/ajax-loader.gif';
function Loader() {

    return (
        <React.Fragment>

            <div id="resultLoading">
                <div className="img_gif">
                    <img src={loaderImg} alt="loader" />
                    <div id="text_loader">Please Wait</div>
                </div>
                <div className="bg"></div>
            </div>
        </React.Fragment>
    );
}

export default Loader;